"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pedido = void 0;
const js_big_decimal_1 = __importDefault(require("js-big-decimal"));
const Observer_Pattern_1 = require("../Observer_Pattern");
const FaixasPreco_1 = require("./FaixasPreco");
const Produto_1 = require("./Produto");
const subject = new Observer_Pattern_1.ConcreteSubject();
class Pedido {
    constructor(cliente, tabela) {
        this.produtos = new Array();
        this.faixa = 'FX1';
        this.transacao = '90100';
        this.pagamento = '003';
        this.status = 'digitado';
        this.faixaManual = false;
        this.cliente = cliente;
        this.tabela = tabela;
    }
    get totalPesoLiquido() {
        let pesoLiquido = new js_big_decimal_1.default('0');
        for (const produto of this.produtos) {
            pesoLiquido = pesoLiquido.add(new js_big_decimal_1.default(produto.pesoProdutoPedido));
        }
        return Number.parseFloat(pesoLiquido.getValue());
    }
    get totalPesoBruto() {
        let pesoBruto = new js_big_decimal_1.default('0');
        for (const produto of this.produtos) {
            pesoBruto = pesoBruto.add(new js_big_decimal_1.default(produto.pesoBrutoProdutoPedido));
        }
        return Number.parseFloat(pesoBruto.getValue());
    }
    get totalPalets() {
        let palets = 0;
        for (const produto of this.produtos) {
            palets += (produto.qtdped / produto.totpalete);
        }
        return palets;
    }
    get totalValor() {
        return Pedido.calcularValorPedido(this);
    }
    get totalVolumes() {
        return this.produtos.reduce((a, b) => a + b.qtdped * 1, 0);
    }
    get totalST() {
        let ST = 0;
        for (const produto of this.produtos) {
            ST += produto.valorST;
        }
        return ST;
    }
    adicionarProduto(produto) {
        if (this.tabela.produtoExisteTabela(produto)) {
            if (this.produtoExisteNoPedido(produto)) {
                return console.error(`Produto de código ${produto.codpro} já incluído na lista`);
            }
            const produtoTabela = this.tabela.obterProdutoTabela(produto);
            if (produtoTabela) {
                const MVA = this.retornaMVAIdeal(produtoTabela);
                if (MVA) {
                    produtoTabela.mvaAjustado = MVA.marluc;
                    produtoTabela.codICMSSubst = MVA.codtst;
                    produtoTabela.aliqInterna = MVA.icmest;
                }
                produtoTabela.aliqInterestadual = this.retornaAliqInterna();
                subject.attach(produtoTabela);
                this.produtos.push(produtoTabela);
                this.faixa = Pedido.obterFaixaPedido(this);
                this.recalcularPedido();
            }
        }
        else {
            return console.error(`Produto de código ${produto.codpro} não existe na tabela de preços`);
        }
    }
    removerProduto(produto) {
        const isExist = this.produtoExisteNoPedido(produto);
        if (!isExist) {
            return console.log(`Produto de código ${produto.codpro} não existe no pedido`);
        }
        const indexProduto = this.produtos.findIndex(p => p.codpro === produto.codpro);
        this.produtos.splice(indexProduto, 1);
        subject.detach(produto);
        this.faixa = Pedido.obterFaixaPedido(this);
        this.recalcularPedido();
    }
    obterProduto(produto) {
        const isExist = this.produtoExisteNoPedido(produto);
        if (!isExist) {
            console.log(`Produto de código ${produto.codpro} não existe no pedido`);
            return undefined;
        }
        const p = this.produtos.find(p => p.codpro == produto.codpro);
        if (p) {
            return new Produto_1.ConcreteProduto(p);
        }
        else {
            return undefined;
        }
    }
    alterarQuantidadeProduto(produto, quantidade) {
        const isExist = this.produtoExisteNoPedido(produto);
        if (!isExist) {
            return console.log(`Produto de código ${produto.codpro} não existe no pedido`);
        }
        const produtoAlterado = this.produtos.find(p => p.codpro === produto.codpro);
        if (produtoAlterado) {
            produtoAlterado.qtdped = quantidade;
            produtoAlterado.fixarFaixa = false;
            this.faixa = Pedido.obterFaixaPedido(this);
            this.recalcularPedido();
        }
    }
    aplicarDescontoAvista(produto, percentual) {
        let descontoAplicado = true;
        if (!this.produtoExisteNoPedido(produto)) {
            console.log(`Produto de código ${produto.codpro} não existe no pedido`);
            descontoAplicado = false;
            return descontoAplicado;
        }
        const produtoAlterado = this.produtos.find(p => p.codpro === produto.codpro);
        if (produtoAlterado) {
            produtoAlterado.desavi = percentual;
            produtoAlterado.descontosInvalidos ? descontoAplicado = false : descontoAplicado = true;
            produtoAlterado.desavi = produtoAlterado.descontosInvalidos ? 0 : percentual;
            this.faixa = Pedido.obterFaixaPedido(this);
            this.recalcularPedido();
        }
        return descontoAplicado;
    }
    aplicarDescontoExtra(produto, percentual) {
        let descontoAplicado = true;
        if (!this.produtoExisteNoPedido(produto)) {
            console.log(`Produto de código ${produto.codpro} não existe no pedido`);
            descontoAplicado = false;
            return descontoAplicado;
        }
        const produtoAlterado = this.produtos.find(p => p.codpro === produto.codpro);
        if (produtoAlterado) {
            produtoAlterado.desext = percentual;
            produtoAlterado.descontosInvalidos ? descontoAplicado = false : descontoAplicado = true;
            produtoAlterado.desext = produtoAlterado.descontosInvalidos ? 0 : percentual;
            this.faixa = Pedido.obterFaixaPedido(this);
            this.recalcularPedido();
        }
        return descontoAplicado;
    }
    aplicarDescontoCargaFechada(produto, percentual) {
        let descontoAplicado = true;
        if (!this.produtoExisteNoPedido(produto)) {
            console.log(`Produto de código ${produto.codpro} não existe no pedido`);
            descontoAplicado = false;
            return descontoAplicado;
        }
        const produtoAlterado = this.produtos.find(p => p.codpro === produto.codpro);
        if (produtoAlterado) {
            produtoAlterado.descar = percentual;
            produtoAlterado.descontosInvalidos ? descontoAplicado = false : descontoAplicado = true;
            produtoAlterado.descar = produtoAlterado.descontosInvalidos ? 0 : percentual;
            this.faixa = Pedido.obterFaixaPedido(this);
            this.recalcularPedido();
        }
        return descontoAplicado;
    }
    aplicarDescontoCampanha(produto, percentual) {
        let descontoAplicado = true;
        if (!this.produtoExisteNoPedido(produto)) {
            console.log(`Produto de código ${produto.codpro} não existe no pedido`);
            descontoAplicado = false;
            return descontoAplicado;
        }
        const produtoAlterado = this.produtos.find(p => p.codpro === produto.codpro);
        if (produtoAlterado) {
            produtoAlterado.descam = percentual;
            produtoAlterado.descontosInvalidos ? descontoAplicado = false : descontoAplicado = true;
            produtoAlterado.descam = produtoAlterado.descontosInvalidos ? 0 : percentual;
            this.faixa = Pedido.obterFaixaPedido(this);
            this.recalcularPedido();
        }
        return descontoAplicado;
    }
    aplicarDescontoCampanhaJulho(produto, percentual) {
        let descontoAplicado = true;
        if (!this.produtoExisteNoPedido(produto)) {
            console.log(`Produto de código ${produto.codpro} não existe no pedido`);
            descontoAplicado = false;
            return descontoAplicado;
        }
        const produtoAlterado = this.produtos.find(p => p.codpro === produto.codpro);
        if (produtoAlterado) {
            produtoAlterado.descontoCampanha = percentual;
            produtoAlterado.descontosInvalidos ? descontoAplicado = false : descontoAplicado = true;
            produtoAlterado.descontoCampanha = produtoAlterado.descontosInvalidos ? 0 : percentual;
            this.faixa = Pedido.obterFaixaPedido(this);
            this.recalcularPedido();
        }
        return descontoAplicado;
    }
    aplicarDescontoXTOP(produto, percentual) {
        let descontoAplicado = true;
        if (!this.produtoExisteNoPedido(produto)) {
            console.log(`Produto de código ${produto.codpro} não existe no pedido`);
            descontoAplicado = false;
            return descontoAplicado;
        }
        const produtoAlterado = this.produtos.find(p => p.codpro === produto.codpro);
        if (produtoAlterado) {
            produtoAlterado.destop = percentual;
            produtoAlterado.descontosInvalidos ? descontoAplicado = false : descontoAplicado = true;
            produtoAlterado.destop = produtoAlterado.descontosInvalidos ? 0 : percentual;
            this.faixa = Pedido.obterFaixaPedido(this);
            this.recalcularPedido();
        }
        return descontoAplicado;
    }
    aplicarDescontoRetiraNaFabrica(produto, percentual) {
        let descontoAplicado = true;
        if (!this.produtoExisteNoPedido(produto)) {
            console.log(`Produto de código ${produto.codpro} não existe no pedido`);
            descontoAplicado = false;
            return descontoAplicado;
        }
        const produtoAlterado = this.produtos.find(p => p.codpro === produto.codpro);
        if (produtoAlterado) {
            produtoAlterado.descontoRetiraNaFabrica = percentual;
            produtoAlterado.descontosInvalidos ? descontoAplicado = false : descontoAplicado = true;
            produtoAlterado.descontoRetiraNaFabrica = produtoAlterado.descontosInvalidos ? 0 : percentual;
            this.faixa = Pedido.obterFaixaPedido(this);
            this.recalcularPedido();
        }
        return descontoAplicado;
    }
    alterarFaixaPreco(faixa) {
        if (this.faixaManual) {
            this.faixa = faixa;
            subject.notify(this.faixa);
        }
        else {
            console.error('Não é possível alterar a faixa se a faixaManual estivar marcada como false');
        }
    }
    alterarValorManualProduto(produto, valor) {
        let descontoAplicado = true;
        if (this.faixaManual) {
            if (!this.produtoExisteNoPedido(produto)) {
                console.log(`Produto de código ${produto.codpro} não existe no pedido`);
                descontoAplicado = false;
                return descontoAplicado;
            }
            const produtoAlterado = this.produtos.find(p => p.codpro === produto.codpro);
            if (produtoAlterado) {
                produtoAlterado.ehValorManual = true;
                produtoAlterado.valorManual = valor;
            }
        }
        else {
            console.error('Não é possível alterar o valor fixo se a faixaManual estivar marcada como false');
            descontoAplicado = false;
            return descontoAplicado;
        }
        return descontoAplicado;
    }
    transformarPedidoParaAprovacao() {
        this.faixaManual = true;
        this.status = 'edicao';
    }
    transformarPedidoPadrao() {
        this.faixaManual = false;
        this.status = 'digitado';
        this.produtos.forEach(p => {
            p.ehValorManual = false;
        });
        this.recalcularPedido();
    }
    recalcularPedido() {
        this.faixa = Pedido.obterFaixaPedido(this);
        subject.notify(this.faixa);
        if (!this.faixaManual) {
            const faixa_depois_notificacao = Pedido.obterFaixaPedido(this);
            if ((this.faixa == 'FX2' && faixa_depois_notificacao == 'FX1') || (this.faixa == 'FX3' && faixa_depois_notificacao == 'FX2')) {
                this.faixa = faixa_depois_notificacao;
                subject.notify(this.faixa);
            }
        }
    }
    produtoExisteNoPedido(produto) {
        return this.produtos.filter(p => p.codpro === produto.codpro).length > 0;
    }
    obterMVASDB() {
        const mockDB = [
            {
                "codtst": 9,
                "sigufs": "MG",
                "codemp": 1,
                "icmest": 12,
                "marluc": 28.78
            },
            {
                "codtst": 2,
                "sigufs": "RJ",
                "codemp": 1,
                "icmest": 12,
                "marluc": 75.97
            },
            {
                "codtst": 1,
                "sigufs": "RJ",
                "codemp": 1,
                "icmest": 12,
                "marluc": 57.73
            },
            {
                "codtst": 3,
                "sigufs": "RJ",
                "codemp": 1,
                "icmest": 12,
                "marluc": 71.64
            },
            {
                "codtst": 4,
                "sigufs": "RJ",
                "codemp": 1,
                "icmest": 12,
                "marluc": 70.27
            },
            {
                "codtst": 5,
                "sigufs": "MG",
                "codemp": 1,
                "icmest": 12,
                "marluc": 44.87
            },
            {
                "codtst": 6,
                "sigufs": "MG",
                "codemp": 1,
                "icmest": 18,
                "marluc": 55.6098
            },
            {
                "codtst": 7,
                "sigufs": "AC",
                "codemp": 1,
                "icmest": 5,
                "marluc": 0
            },
            {
                "codtst": 7,
                "sigufs": "RS",
                "codemp": 1,
                "icmest": 6,
                "marluc": 0
            },
            {
                "codtst": 10,
                "sigufs": "AC",
                "codemp": 1,
                "icmest": 17,
                "marluc": 62.47
            },
            {
                "codtst": 10,
                "sigufs": "AL",
                "codemp": 1,
                "icmest": 18,
                "marluc": 89.01
            },
            {
                "codtst": 10,
                "sigufs": "AM",
                "codemp": 1,
                "icmest": 18,
                "marluc": 58
            },
            {
                "codtst": 10,
                "sigufs": "AP",
                "codemp": 1,
                "icmest": 18,
                "marluc": 80.33
            },
            {
                "codtst": 10,
                "sigufs": "MG",
                "codemp": 1,
                "icmest": 18,
                "marluc": 66.34
            },
            {
                "codtst": 10,
                "sigufs": "MS",
                "codemp": 1,
                "icmest": 17,
                "marluc": 73.23
            },
            {
                "codtst": 7,
                "sigufs": "MG",
                "codemp": 1,
                "icmest": 12,
                "marluc": 0
            },
            {
                "codtst": 7,
                "sigufs": "SP",
                "codemp": 1,
                "icmest": 12,
                "marluc": 0
            },
            {
                "codtst": 6,
                "sigufs": "AM",
                "codemp": 1,
                "icmest": 18,
                "marluc": 40
            },
            {
                "codtst": 6,
                "sigufs": "MT",
                "codemp": 1,
                "icmest": 17,
                "marluc": 45.52
            },
            {
                "codtst": 6,
                "sigufs": "AC",
                "codemp": 1,
                "icmest": 17,
                "marluc": 53.73
            },
            {
                "codtst": 6,
                "sigufs": "AL",
                "codemp": 1,
                "icmest": 18,
                "marluc": 38.88
            },
            {
                "codtst": 6,
                "sigufs": "AP",
                "codemp": 1,
                "icmest": 18,
                "marluc": 55.61
            },
            {
                "codtst": 6,
                "sigufs": "MS",
                "codemp": 1,
                "icmest": 17,
                "marluc": 54.16
            },
            {
                "codtst": 10,
                "sigufs": "MT",
                "codemp": 1,
                "icmest": 17,
                "marluc": 45.52
            }
        ];
        return mockDB;
    }
    retornaMVAIdeal(produto) {
        const MOCK_E019SUB = this.obterMVASDB();
        const MVA = MOCK_E019SUB.find(x => x.codtst == Number(produto.codICMSSubst) && x.sigufs == this.cliente.sigufs && this.cliente.usu_bensts != 'S');
        return MVA;
    }
    retornaAliqInterna() {
        switch (this.cliente.sigufs) {
            case 'SP':
                return 12;
            case 'MG':
                return 12;
            case 'PR':
                return 12;
            case 'SC':
                return 12;
            case 'RS':
                return 12;
            case 'RJ':
                return 20;
            default:
                return 7;
        }
    }
    static obterFaixaPedido(pedido) {
        if (pedido.faixaManual) {
            console.log('==>> Pedido é faixa manual', pedido.faixa);
            return pedido.faixa;
        }
        else if (pedido.cliente.codtpr != ' ') {
            console.log('==>> Cliente tem tabela especial', pedido.faixa);
            return 'FX3';
        }
        else {
            const valorPedido = Pedido.calcularValorPedido(pedido);
            if (valorPedido > FaixasPreco_1.FaixaPreco.FX1.min && valorPedido <= FaixasPreco_1.FaixaPreco.FX1.max) {
                return 'FX1';
            }
            else if (valorPedido > FaixasPreco_1.FaixaPreco.FX2.min && valorPedido <= FaixasPreco_1.FaixaPreco.FX2.max) {
                return 'FX2';
            }
            else if (valorPedido > FaixasPreco_1.FaixaPreco.FX3.min) {
                return 'FX3';
            }
            else {
                return 'FX1';
            }
        }
    }
    static calcularValorPedido(pedido) {
        let totalPedido = new js_big_decimal_1.default('0');
        for (const produto of pedido.produtos) {
            totalPedido = totalPedido.add(new js_big_decimal_1.default(produto.vlrProdutoPedido()));
        }
        return Number.parseFloat(totalPedido.getValue());
    }
}
exports.Pedido = Pedido;
